import axios from 'axios';
import { getLabel } from "./labels.js";

var DataLayer = {
    wsUrl: "/api/jobs",
    init() {
        let ws = document.querySelector(".jobPostingsAppConfig input[name='ws-url']");
        if (ws) this.wsUrl = ws.value;
    },
    serializeFilters(filters) {
        if (!filters) return "";
        let ret = "";
        for (let p in filters) {
            if (filters.hasOwnProperty(p) && filters[p]) {
                if (typeof(filters[p]) === "string") {
                    if (ret) ret+="&";
                    ret+=`${p}=${filters[p]}`;
                }
                else if (filters[p].id) {
                    if (ret) ret+="&";
                    ret+=`${p}=${filters[p].id}`;
                }
            }
        }
        return "?"+ret;
    },
    getJobPostings(filters, fixedFilter) {
        if (!this.wsUrl) return Promise.reject("The URL of the web service has not been configured.")
        let url = `${this.wsUrl}/postings`;
        if (filters) {
            url += this.serializeFilters(filters);
        }
        if (fixedFilter) {
            if (url.indexOf('?') == -1) url += "?";
            else url+="&";
            url += fixedFilter;
        }
        return axios.get(url);
    },
    getDistinctValues(objects, property) {
        let dict = {};
        if (objects && property) {
            objects.map(o => {
                if (o.hasOwnProperty(property)) {
                    dict[o[property]] = o.name;
                }
            });
        }
        let ret = [];
        for (var p in dict) {
            if (dict.hasOwnProperty(p)) {
                ret.push({id: p, name: dict[p]});
            }
        }
        ret.sort((a, b) => {
            if (a.name < b.name) return -1;
            else if (a.name > b.name) return 1;
            else return 0;
        });
        return ret;
    },
    getFilterOptions(jobs) {
        if (!jobs) return;
        let countries = [];
        let regions = [];
        let languages = [];
        let families = [];
        let types = [];
        let cities = [];

        jobs.map(job => {
            /*let parts = job.location.split(',');
            if (parts && parts.length > 0) countries.push({id: parts[0].trim(), name: parts[0].trim()});
            if (parts && parts.length > 1) cities.push({id: parts[1].trim(), name: parts[1].trim()});*/
            if (job.calculatedCountry) {
                if (job.calculatedCountry.name) {
                    countries.push({id: job.calculatedCountry.id, name: job.calculatedCountry.name});
                } else {
                    countries.push({id: job.calculatedCountry.id, name: getLabel("locationGlobal")});   
                }
            }
            
            if (job.calculatedCity) cities.push({id: job.calculatedCity, name: job.calculatedCity});
            if (job.calculatedLanguage) languages.push({id: job.calculatedLanguage.id, name: job.calculatedLanguage.name});
            if (job.calculatedJobFamily) families.push({id: job.calculatedJobFamily.id, name: job.calculatedJobFamily.name});
            if (job.calculatedJobType) types.push({id: job.calculatedJobType.id, name: job.calculatedJobType.name});
            let region = this.extractRegion(job.location);
            if (region) regions.push({id: region, name: region});
        });

        return {
            countries: this.getDistinctValues(countries, "id"),
            languages: this.getDistinctValues(languages, "id"),
            families: this.getDistinctValues(families, "id"),
            types: this.getDistinctValues(types, "id"),
            cities: this.getDistinctValues(cities, "id"),
            regions: this.getDistinctValues(regions, "id")
        };
    },
    extractRegion(location) {
        if (!location) return "";
        let parts = location.split(",");
        if (!parts || parts.length !== 3) return "";
        return parts[2].trim();
    },
    getInitialFilterTags(initialFilters, filterOptions) {
        if (!initialFilters || !filterOptions) return null;
        let ret = {};
        initialFilters.split('&').map(filter => {
            let pair = filter.split('=');
            let array = null;
            if (pair[0] === "country") array = filterOptions.countries;
            if (pair[0] === "region") array = filterOptions.regions;
            else if (pair[0] === "family") array = filterOptions.families;
            else if (pair[0] === "type") array = filterOptions.types;
            if (array !== null) {
                const val = array.find((el) => {
                    return el.id === decodeURIComponent(pair[1]); }
                );
                if (val) {
                    ret[pair[0]] = { id: val.id, label: val.name };
                }
            }
        });
        return ret;
    }
};

export default DataLayer;